import { CascaderOption } from 'types/base';
import { isBkcProductCategory } from './product-list/form-items/authentication-config';

export type BkcAiAuthenticationProduct = {
  productCategoryIdList: number[];
  authenticationBagId?: number;
};

export type BkcAiAuthenticationDetail = {
  latestTask: { status: string } | null;
  latestResult: unknown;
};

export type BkcAiAuthenticationValidationResult =
  | { valid: true }
  | {
      valid: false;
      productIndex: number;
      reason: 'missing' | 'no-task' | 'fetch-failed';
    };

export const validateBkcAiAuthentication = async ({
  productList,
  canSkip,
  productCategoryCascaderOptions,
  fetchAuthenticationDetail,
}: {
  productList: BkcAiAuthenticationProduct[];
  canSkip: boolean;
  productCategoryCascaderOptions: CascaderOption[];
  fetchAuthenticationDetail: (
    authenticationBagId: number,
  ) => Promise<BkcAiAuthenticationDetail>;
}): Promise<BkcAiAuthenticationValidationResult> => {
  const bkcProducts = productList
    .map((item, index) => ({
      index,
      authenticationBagId: item.authenticationBagId,
      isBKC: isBkcProductCategory(
        item.productCategoryIdList,
        productCategoryCascaderOptions,
      ),
    }))
    .filter((item) => item.isBKC);

  if (!bkcProducts.length) return { valid: true };
  if (canSkip) return { valid: true };

  for (const item of bkcProducts) {
    if (!item.authenticationBagId) {
      return { valid: false, productIndex: item.index, reason: 'missing' };
    }
  }

  // authenticationBagId 在第一张鉴定图上传时就会生成，必须确认鉴定任务已发起（点过"开始AI鉴定"）
  for (const item of bkcProducts) {
    let detail: BkcAiAuthenticationDetail;
    try {
      detail = await fetchAuthenticationDetail(item.authenticationBagId!);
    } catch {
      return { valid: false, productIndex: item.index, reason: 'fetch-failed' };
    }

    if (!detail.latestTask) {
      return {
        valid: false,
        productIndex: item.index,
        reason: 'no-task',
      };
    }
  }

  return { valid: true };
};